import { requestGet } from '@/common/request';

export default {
  // 获取用户有权限的活动计划数据
  async visibleActivityList(query) {
    return await requestGet('/data/visibleActivityList', query);
  },

  // 获取会场数据以及pv数据
  async activityRoomList(query) {
    return await requestGet('/data/activityRoomList', query);
  },

  // 获取活动的流量来源统计信息
  async activityFlowStatistics(query) {
    return await requestGet('/data/activityFlowStatistics', query);
  },

  // 获取会场的流量来源统计信息
  async roomFlowStatistics(query) {
    return await requestGet('/data/roomFlowStatistics', query);
  },

  // 流量去向各维度数据信息
  async outStatistics(query) {
    return await requestGet('/data/flowOutStatistics', query);
  },

  // 流量去向数据趋势
  async flowOutTrend(query) {
    return await requestGet('/data/flowOutTrend', query);
  },

  // 流量去向饼图数据
  async flowRoom(query) {
    return await requestGet('/data/flowRoom', query);
  },
};
